import { render, staticRenderFns } from "./forma_pago.vue?vue&type=template&id=19cc25ce&"
import script from "./forma_pago.vue?vue&type=script&lang=js&"
export * from "./forma_pago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports